import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';

import moment from 'moment';

interface StateProps {
  crypto?: boolean;
  toWithdraw?: boolean;
}
const AccountConfirmationPage = () => {
  const history = useHistory();
  const date = moment().format('MMM Do YY');
  const location = useLocation();
  const { crypto, toWithdraw } = location.state as StateProps;

  useEffect(() => {
    setTimeout(function () {
      handleClick();
    }, 5000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = () => {
    if (toWithdraw) {
      history.push('/user/banking/withdraw');
    } else {
      history.push({
        pathname: '/user/banking/account-manager',
        state: { addingAccount: false },
      });
    }
  };
  return (
    <MainWrapper>
      <Wrapper>
        <TopWrapper>
          <CheckmarkWrapper>
            <Checkmark></Checkmark>
          </CheckmarkWrapper>
          <Date>{date}</Date>
        </TopWrapper>
        <Header>
          You’ve successfully set up {!crypto ? 'a Bank' : 'your Crypto'}{' '}
          account.
        </Header>

        <Text>
          You can now receive funds and pay with this account on trac.
        </Text>
      </Wrapper>

      <Wallet onClick={handleClick}>
        <span className="shortly">Redirecting you shortly...</span>
        <span>
          Continue to {toWithdraw ? 'Withdraw' : 'Payment Accounts'} &#8594;
        </span>
      </Wallet>
    </MainWrapper>
  );
};
const Date = styled('span')`
  font-size: 12px;
  opacity: 0.5;
`;
const MainWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`;
const TopWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 19px;

  margin-top: -174px;
  background: #fff;
`;

const Wallet = styled('div')`
  margin-top: 100px;
  cursor: pointer;
  font-size: 12px;
  width: 463px;
  display: flex;
  justify-content: space-between;
  .shortly {
    font-weight: 700;
  }
`;
const Header = styled('p')`
  font-size: 24px;
  width: 425px;
`;
const Text = styled('p')`
  color: #32343c;
  font-size: 16px;
  width: 425px;

  opacity: 0.5;
  margin-top: -5px;
`;
const CheckmarkWrapper = styled('div')`
  /* border-radius: 100px; */
  display: flex;
  border-radius: 100%;
  background-color: #a2d76b;
  border: 1px solid #a2d76b;
  width: 32px;
  height: 32px;
  /* border: 1px solid black; */
  justify-content: center;
  align-items: center;
`;
const Checkmark = styled('span')`
  font-size: 36px;
  transform: rotate(45deg);
  height: 16px;
  width: 9px;
  border-bottom: 3px solid #fff;
  border-right: 3px solid #fff;
  margin-bottom: 3px;
`;
export default AccountConfirmationPage;
